import React from 'react'

function PortalAccessIcon({ color = "#7e7e7e" }) {
  return (
    <svg id="lock_open_black_24dp_1_" data-name="lock_open_black_24dp (1)" xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24">
      <path id="Path_205721" data-name="Path 205721" d="M0,0H24V24H0Z" fill="none" />
      <g id="noun-lock-6307313" transform="translate(-21.09 -15.8)">
        <g id="Group_89524" data-name="Group 89524" transform="translate(25.09 17.8)">
          <path id="Path_205723" data-name="Path 205723" d="M32.865,17.8a5.8,5.8,0,0,0-5.787,5.787v2.741h-.05a1.94,1.94,0,0,0-1.938,1.938v7.7A1.94,1.94,0,0,0,27.028,37.9H38.7a1.94,1.94,0,0,0,1.938-1.938v-7.7A1.94,1.94,0,0,0,38.7,26.328h-.05V23.587A5.8,5.8,0,0,0,32.865,17.8Zm-4.538,5.787a4.538,4.538,0,0,1,9.077,0v2.741H28.327ZM39.4,28.266v7.7a.69.69,0,0,1-.69.69H27.028a.69.69,0,0,1-.69-.69v-7.7a.69.69,0,0,1,.69-.69H38.7A.693.693,0,0,1,39.4,28.266Z" transform="translate(-25.09 -17.8)" fill={color} />
          <path id="Path_205724" data-name="Path 205724" d="M48.624,61.329a.626.626,0,0,0,.624-.624V59.094a.624.624,0,0,0-1.249,0V60.7A.624.624,0,0,0,48.624,61.329Z" transform="translate(-40.849 -45.775)" fill={color} />
        </g>
      </g>
    </svg>
  )
}

export default PortalAccessIcon